// extracted by mini-css-extract-plugin
export default {"container":"segJaU","column":"bpKXRE","row":"waM_Qh"};